import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { AuthLayout } from '../../../components/generic/Layouts/AuthLayout'
import { Eyebrow } from '../../../components/generic/ui/Eyebrow'
import { AuthHeading } from '../../../components/generic/ui/Heading'
import { TextInput, PasswordInput } from '../../../components/generic/ui/Input'
import { AccentButton } from '../../../components/generic/ui/Button'
import OtpCodeInput from '../../../components/generic/ui/otp-code-input/OtpCodeInput'
import { UseForgotFormReturn } from './useForgotForm'

export const ForgotFormView: React.FC<UseForgotFormReturn> = (p) => (
  <AuthLayout>
    <Eyebrow>AGROLINE / RESET PASSWORD</Eyebrow>
    {p.isShowSmsStep ? (
      <>
        <AuthHeading subtitle={`שלחנו קוד SMS למספר ${p.tel}`}>
          אימות<br />טלפון
        </AuthHeading>
        <Form onSubmit={(e) => { e.preventDefault(); p.verifyRecoveryCode() }}>
          <OtpCodeInput
            length={4}
            onCodeChange={p.handleCodeSms}
            label="הזן את הקוד שקיבלת ב-SMS"
            autoFocus
          />
          <AccentButton
            type="submit"
            disabled={p.isAwaitingCodeVerifying || p.codeSMS.length !== 4}
          >
            {p.isAwaitingCodeVerifying ? 'מאמת...' : 'אמת קוד'}
          </AccentButton>
          <AccentButton type="button" variant="ghost" onClick={p.cancelSmsStep}>
            חזרה
          </AccentButton>
        </Form>
      </>
    ) : (
      <>
        <AuthHeading subtitle="הזינו שם משתמש וטלפון לקבלת קוד אימות">
          איפוס<br />סיסמה
        </AuthHeading>
        <Form onSubmit={p.handleChangePassword}>
          <TextInput
            label="שם משתמש"
            name="username"
            type="text"
            placeholder="moshe.cohen"
            autoComplete="off"
            value={p.userName}
            onChange={p.handleUserName}
            disabled={p.isMatchCodeRecovery}
            required
          />

          <TextInput
            label="טלפון נייד"
            name="phone"
            type="tel"
            inputMode="numeric"
            placeholder="0501234567"
            value={p.tel}
            onChange={p.handleTelephone}
            disabled={p.isMatchCodeRecovery}
            helperText={
              !p.isMatchCodeRecovery
                ? p.restDidgitsTel > 0
                  ? `נשארו ${p.restDidgitsTel} ספרות`
                  : undefined
                : 'הטלפון אומת'
            }
          />

          {!p.isMatchCodeRecovery && (
            <AccentButton
              type="button"
              onClick={p.sendSmsRecovery}
              disabled={p.tel.length !== 10 || !p.userName}
            >
              שלח קוד
            </AccentButton>
          )}

          {p.isMatchCodeRecovery && (
            <>
              <PasswordInput
                label="סיסמה"
                name="password"
                placeholder="••••••••"
                autoComplete="new-password"
                value={p.password}
                onChange={p.handlePassword}
                required
              />
              <PasswordInput
                label="לאשר את הסיסמה"
                name="confirmPassword"
                placeholder="••••••••"
                autoComplete="new-password"
                value={p.confirmPassword}
                onChange={p.handleConfirmPassword}
                error={
                  p.password && p.confirmPassword && p.password !== p.confirmPassword
                    ? 'סיסמאות לא תואמות'
                    : undefined
                }
                required
              />
              <AccentButton type="submit" disabled={p.isAlertPassword}>
                שנה סיסמה
              </AccentButton>
            </>
          )}

          <BottomRow>
            <Link to="/login">חזרה לכניסה</Link>
          </BottomRow>
        </Form>
      </>
    )}
  </AuthLayout>
)
ForgotFormView.displayName = 'ForgotFormView'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`

const BottomRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  font-size: 0.8125rem;

  a {
    color: ${({ theme }) => theme.colors.ink2};
    text-decoration: none;
    font-weight: 500;
    border-bottom: 1px solid transparent;
    transition: border-color ${({ theme }) => theme.motion.fast},
      color ${({ theme }) => theme.motion.fast};
  }

  a:hover {
    color: ${({ theme }) => theme.colors.ink};
    border-bottom-color: ${({ theme }) => theme.colors.ink};
  }
`

export default ForgotFormView
